export class UbicacionUnidadDocumental {

    centro: string;
    domicilioCentro: string;
    poblacionCentro: string;
    CP: string;
    provincia: string;
    telefonoCentro: string;
    faxCentro: string;
    area: string;
    emailResponsableArea: string;
    piso: number;
    estanteria: number;
    celda: number;
    posicion: number;
    contenedorId: any;
    numContenedor: number;
    contenedorAjeno: string;
    tipoContenedor: string;

    constructor() { }

    static toModel(json: string): UbicacionUnidadDocumental {
        const data = JSON.parse(json);
        if (data === null || typeof data === 'string') {
            return null;
        }
        const toReturn = new UbicacionUnidadDocumental();
        toReturn.centro = data.CENTRO;
        toReturn.domicilioCentro = data.DOMICILIO_CENTRO;
        toReturn.poblacionCentro = data.POBLACION_CENTRO;
        toReturn.CP = data.CP;
        toReturn.provincia = data.PROVINCIA;
        toReturn.telefonoCentro = data.TFNO_CENTRO;
        toReturn.faxCentro = data.FAX_CENTRO;
        toReturn.area = data.AREA;
        toReturn.emailResponsableArea = data.EMAIL_RESPONSABLE_AREA;
        toReturn.piso = data.PISO;
        toReturn.estanteria = data.ESTANTERIA;
        toReturn.celda = data.CELDA;
        toReturn.posicion = data.POSICION;
        toReturn.contenedorId = data.ID_CONTENEDOR;
        toReturn.numContenedor = data.NUM_CONTENEDOR;
        toReturn.contenedorAjeno = data.CONTENEDOR_AJENO;
        toReturn.tipoContenedor = data.TIPO_CONTENEDOR;

        return toReturn;
    }
}
